import { Observable } from 'rxjs';
import { HTTPRequestMethodEnum, NetworkRequestOptions } from '../interfaces/request';
import { convertToPromise } from '../utils/promise';
import { RxRequestService } from './rx-request.service';

export let courier: CourierService;

export interface CourierNetworkRequestOptions extends NetworkRequestOptions {
  signal?: AbortSignal;
}

export class CourierService {
  static deps = [
    RxRequestService
  ];

  constructor(
    private _rxRequestService: RxRequestService
  ) {
    courier = this;
  }

  get<T = any, D = any>(url: string, networkOpts: CourierNetworkRequestOptions = {}) {
    return this._convertToPromise(this._rxRequestService.get<T, D>(url, networkOpts), networkOpts);
  }

  post<T = any, D = any>(url: string, networkOpts: CourierNetworkRequestOptions = {}, params?: any) {
    return this._convertToPromise(this._rxRequestService.post<T, D>(url, networkOpts, params), networkOpts);
  }

  put<T = any, D = any>(url: string, networkOpts: CourierNetworkRequestOptions = {}, params?: any) {
    return this._convertToPromise(this._rxRequestService.put<T, D>(url, networkOpts, params), networkOpts);
  }

  delete<T = any, D = any>(url: string, networkOpts: CourierNetworkRequestOptions = {}) {
    return this._convertToPromise(this._rxRequestService.delete<T, D>(url, networkOpts), networkOpts);
  }

  sendRequest<T = any, D = any>(
    method: HTTPRequestMethodEnum,
    url: string,
    params?: any,
    opts: NetworkRequestOptions = {}) {
    return this._convertToPromise(this._rxRequestService.sendRequest<T, D>(method, url, params, opts), opts);
  }

  private _convertToPromise(observable: Observable<any>, networkOpts: CourierNetworkRequestOptions) {
    return convertToPromise(observable, networkOpts.signal);
  }
}
